import { webKnots } from '../../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfVWeb } from './parts/verticalParts'

export const w30Web = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor

  // 横上パーツ
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1, printLeatherTypeValue)
  // 縦パーツ
  await verticalPartOfVWeb(ctx, webColor2 || webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 捕球面上のウェブ結び目
  webKnots(ctx, laceColor, -120, 120)
}
